import React from 'react'
import styled from 'styled-components'
import ErrorBoundary from 'components/errorBoundary'
// import Typography from 'components/typography'
// import { useWindowSize } from 'react-use'
import VideoCamera from 'images/icons/Classwin-VideoCamera-blue.svg'
import OnlineCourse from 'images/icons/Classwin-onlineCourse-blue.svg'
import TimeIcon from 'images/icons/Classwin-Time-blue.svg'
import LevelCourseIcon from 'images/icons/Classwin-LevelCourse-blue.svg'
import StudentIcon from 'images/icons/Classwin-Student-blue.svg'
import DocumentIcon from 'images/icons/Classwin-Document-blue.svg'

const Container = styled.div`
  width: 100%;
  margin-bottom: 35px;

  @media (max-width: 720px) {
    margin-bottom: 25px;
  }
`
const Grid = styled.div`
  width: 100%;
  display: grid;
  grid-gap: 10px;
  grid-template-columns: repeat(2, 1fr);
`
const Icon = styled.img`
  width: 10px;
  height: 10px;
  opacity: 0.8;
`
const Typography = styled.div``

const Item = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 15px;
`

const Summary = (props) => {
  const { course, numberOfStudents, lectures, locale } = props
  const isTh = locale === 'th'
  // const { width } = useWindowSize()
  const lectureNum = lectures.filter((item) => item.type === '').length
  const videoNum = lectures.filter((item) => item.type === '' && item?.videoLink !== '').length
  const estimateTimeUsageHr = course?.estimateTimeUsageHr || 0
  const estimateTimeUsageMin = course?.estimateTimeUsageMin || 0
  const level = course?.level?.name || ''

  const studentText = (num) => {
    if (num === 1) return isTh ? `${num} ผู้เรียน` : `${num} Student`
    if (num > 1) return isTh ? `${num} ผู้เรียน` : `${num} Students`
    return isTh ? `มาเป็นผู้เรียนคนแรกสิ!` : `Don't miss your chance to be the first!`
  }

  const typeText = () => {
    const type = course?.type

    switch (type) {
      case 'online':
        return isTh ? 'คอร์สออนไลน์' : 'Online Course'
      case 'classroom':
        return isTh ? 'คอร์สคลาสรูม' : 'Classroom Course'
      default:
        return type
    }
  }

  const timeText = (hr, min) => {
    if (hr <= 0 && min > 0) return isTh ? `${min} นาที` : `${min} ${min > 1 ? 'mins' : 'min'}`
    if (hr > 0 && min <= 0) return isTh ? `${hr} ชม.` : `${hr} ${hr > 1 ? 'hrs' : 'hr'}`
    if (hr > 0 && min > 0)
      return isTh
        ? `${hr} ชม. ${min} นาที`
        : `${hr} ${hr > 1 ? 'hrs' : 'hr'} ${min} ${min > 1 ? 'mins' : 'min'}`
    return isTh ? `- ชม. - นาที` : `- hr - min`
  }

  const data = [
    {
      icon: StudentIcon,
      value: studentText(numberOfStudents),
      isHidden: false,
    },
    {
      icon: VideoCamera,
      value: isTh ? `${videoNum} วิดีโอ` : `${videoNum} ${videoNum > 1 ? 'Videos' : 'Video'}`,
      isHidden: videoNum <= 0,
    },
    {
      icon: DocumentIcon,
      value: isTh
        ? `${lectureNum} เลคเชอร์`
        : `${lectureNum} ${lectureNum > 1 ? 'Lectures' : 'Lecture'}`,
      isHidden: lectureNum <= 0,
    },
    {
      icon: TimeIcon,
      value: timeText(estimateTimeUsageHr, estimateTimeUsageMin),
      isHidden: estimateTimeUsageHr <= 0 && estimateTimeUsageMin <= 0,
    },
    { icon: OnlineCourse, value: typeText(), isHidden: false },
    { icon: LevelCourseIcon, value: level, isHidden: !level },
  ]
  return (
    <ErrorBoundary>
      <Container>
        <Grid>
          {data
            .filter((item) => !item.isHidden)
            .map((item, index) => (
              <Item key={index}>
                <Icon
                  src={item.icon}
                  style={{
                    width: props.fontSize ? '14px' : '10px',
                    height: props.fontSize ? '14px' : '10px',
                  }}
                />
                <Typography
                  styled={{
                    fontSize: props.fontSize ? '12px' : '10px',
                    color: '#64748B',
                  }}
                  fontWeight={400}
                >
                  {item.value}
                </Typography>
              </Item>
            ))}
        </Grid>
      </Container>
    </ErrorBoundary>
  )
}

export default Summary
